import React from "react"
import { Dialog, DialogProps, styled } from "@mui/material"

import { colors } from "theme"

type ModalType = "default" | "medium" | "thin"

type Props = React.HTMLAttributes<HTMLDivElement> &
  DialogProps & {
    type: ModalType
    dark?: boolean
  }

const paperStyles = (type: ModalType) => {
  switch (type) {
    case "thin":
      return { maxWidth: "431px", minHeight: "auto" }
    case "medium":
      return { maxWidth: "720px", minHeight: "auto" }
    default:
      return { maxWidth: "982px", minHeight: "658px" }
  }
}

const contentStyles = (type: ModalType) => {
  switch (type) {
    case "thin":
      return { padding: "0 32px 32px 32px", marginTop: "32px" }
    case "medium":
      return { padding: "0 32px 32px 32px", marginTop: "32px" }
    default:
      return { padding: "0 50px 46px 50px", marginTop: "83px" }
  }
}

const ModalComponent = styled(
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  ({ type, dark, children, ...restProps }: Props) => {
    return <Dialog {...restProps}>{children}</Dialog>
  },
)(({ theme, type = "default", dark = false }) => ({
  "& .MuiDialog-container": {
    "& .MuiDialog-paper": {
      ...paperStyles(type),
      alignSelf: "flex-start",
      backgroundColor: dark ? colors.ghostWhite : colors.white,
      borderRadius: "30px",
      boxShadow: "none",
      margin: "50px 0 0 0",
      padding: "0",
      width: "100%",
      [theme.breakpoints.down("lg")]: {
        margin: "6px",
      },
    },
    "& .MuiDialogContent-root": {
      ...contentStyles(type),
      position: "relative",
      [theme.breakpoints.down("lg")]: {
        padding: "22px",
        margin: "0",
      },
    },
  },
}))

ModalComponent.defaultProps = {
  type: "default",
  dark: false,
}

export default ModalComponent
